import { FocusHandler } from "../../focus_handlers";
import NodeHandler from "../../node_handler";
import { createElement, appendTo } from "../../../functions/dom";

class AbstractField extends NodeHandler{ //focusable
    __before_init(){
        this.registerEvents('changed')
        if(this.node){
            this.__init_dom_actions(this.node, {
                'click': function(event){
                    event.stopPropagation()
                }
            })
        }

        this.registerEvents('invalid_rebuild')

        this.name = this.node.getAttribute('data-name')
        this.__init_dom('errors','.js-form-field__errors')
        this.__init_options()
        this.addEventListener('changed', this.__onChanged.bind(this))
    }
    __init_options(){
        const json__options = this.node.getAttribute('data-json-options')
        let options = {};
        if(json__options){
            try{
                options = JSON.parse(json__options)
            }catch (e){
                console.log(e)
            }
        }
        this.options = options
    }
    __init(){}
    __onChanged(event){
        this.hideErrors()
    }
    focus(){
        FocusHandler.Focus(this)
    }
    setErrors(messages){
        this.node.classList.add('has--errors')
        this.dom.errors.innerHTML = ''
        appendTo(this.dom.errors, createElement('ul', ['errorlist']))
            .appendList(
                messages
                    .map(
                        message_object => 
                            message_object.message.trim() 
                                ? createElement('li', [], null, message_object.message)
                                : null
                    ))
    }
    hideErrors(){
        this.node.classList.remove('has--errors')
    }
}

export default AbstractField